import type { MessageGroup, ThreadMessage } from "../types/thread";

type InterMessageGroup = {
    messages: ThreadMessage[];
    indices: number[];
};

const createNewGroup = (message: ThreadMessage, index: number): InterMessageGroup => ({
    messages: [message],
    indices: [index],
});

const isAiResponseToHuman = (current: ThreadMessage, previous?: ThreadMessage): boolean =>
    previous?.type === "human" && current.type === "ai";

export const groupHumanRequestsWithAiResponses = (messages: readonly ThreadMessage[]): readonly MessageGroup[] => {
    if (messages.length === 0) {
        return [];
    }

    const groups: InterMessageGroup[] = [];

    messages.forEach((message, index) => {
        const previousMessage: ThreadMessage | undefined = messages[index - 1];
        const currentGroup: InterMessageGroup | undefined = groups[groups.length - 1];

        if (!currentGroup || !isAiResponseToHuman(message, previousMessage)) {
            groups.push(createNewGroup(message, index));
        } else {
            currentGroup.messages.push(message);
            currentGroup.indices.push(index);
        }
    });

    return groups;
};

export const defaultGroupMessages = (messages: readonly ThreadMessage[]): readonly MessageGroup[] =>
    messages.map((m, i) => createNewGroup(m, i));
